import React, { useEffect, useState } from 'react';
import client from '../api/client';
import ViewsConversionCard from './ViewsConversionCard';
import SourceMixDonut from './SourceMixDonut';
import './marketingShared.css';
import './TrafficAttribution.css';

const TrafficConversionCard = ({
  teamId,
  confirmId,
  attributionWindowDays,
  viewsConversion: viewsConversionProp,
  sourcePerformance: sourcePerformanceProp,
  sectionNumber,
}) => {
  const hasInjectedData = viewsConversionProp !== undefined || sourcePerformanceProp !== undefined;
  const shouldFetch = !hasInjectedData && Boolean(teamId) && Boolean(confirmId);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(shouldFetch);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!shouldFetch) {
      return undefined;
    }

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    client
      .get(`/teams/${teamId}/confirms/${confirmId}/marketing_insights/traffic`, {
        signal: controller.signal,
      })
      .then((response) => setData(response.data))
      .catch((err) => {
        if (err.name === 'CanceledError' || err.name === 'AbortError') return;
        setError(err);
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [shouldFetch, teamId, confirmId]);

  const viewsConversion = hasInjectedData ? viewsConversionProp : data?.views_conversion;
  const sourcePerformance = hasInjectedData ? sourcePerformanceProp : data?.source_performance;

  const windowLabel = attributionWindowDays ? `${attributionWindowDays}-day window` : 'all-time';

  return (
    <>
      <div className="mi-section-heading mi-section-heading--traffic">
        <h2>
          {sectionNumber !== undefined && <span className="mi-section-num">{sectionNumber}</span>}
          <span className="mi-section-title">Traffic &amp; conversion</span>
          <span className="mi-section-prompt">— is this a traffic problem or a conversion problem?</span>
        </h2>
        <div className="mi-traffic-meta">
          <span className="mi-traffic-meta__label">
            Attribution · last touch · {windowLabel}
          </span>
        </div>
      </div>

      {loading && (
        <div className="mi-traffic-loading" role="status" aria-live="polite">
          Loading traffic insights…
        </div>
      )}
      {error && !loading && (
        <div className="mi-traffic-error" role="alert">
          Couldn't load traffic insights. Refresh to try again.
        </div>
      )}
      {!loading && !error && (
        <div className="mi-traffic__grid">
          <ViewsConversionCard data={viewsConversion} />
          <SourceMixDonut
            rows={sourcePerformance?.rows}
            totalRevenue={sourcePerformance?.total_revenue}
            attributionWindow={attributionWindowDays}
          />
        </div>
      )}
    </>
  );
};

export default TrafficConversionCard;
